// local
import { HueSyncApi } from "./api";

new HueSyncApi();
